import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/update-duck';

const { Types, Creators } = createActions(
  {
    request: ['id', 'putData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'UPDATE_CARRIER_AREA_CONTACT_' }
);

export interface UpdateCarrierAreaContactState extends IState {}

const INITIAL_STATE: UpdateCarrierAreaContactState = {
  loading: false,
  error: null,
};

const request = (state: UpdateCarrierAreaContactState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: UpdateCarrierAreaContactState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: UpdateCarrierAreaContactState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const updateCarrierAreaContact = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UpdateCarrierAreaContactTypes = Types;
export const UpdateCarrierAreaContactActions = Creators;
